/*
 * Corte das cores do card pela LARGURA, e nao por um numero fixo.
 *
 * O tema corta em N cores (setting "Number of option's values to display") e
 * poe um "+N" no fim, mesmo quando sobrava espaco na linha. Aqui o card 6
 * renderiza todas as cores (flag `fit_row` no product-card-option.liquid) e
 * este arquivo esconde apenas as que nao couberem, acendendo o "+N" — que e o
 * proprio elemento do tema, entao continua abrindo o quick view.
 *
 * A medida e feita no DOM (borda direita de cada amostra contra a da linha) em
 * vez de na conta largura/gap: assim vale para qualquer tamanho de amostra e
 * para o card em qualquer coluna da grade, sem repetir aqui os numeros do CSS.
 */
(function () {
  const ROW = ".m-product-card--style-6 pcard-swatch .m-product-option--content";
  const NODE = ".m-product-option--node";
  const HIDDEN = "bs-swatch-node--hidden";
  const MORE = ".bs-swatch-more";
  const MORE_EMPTY = "bs-swatch-more--empty";
  // enquanto a linha nao foi medida ela fica cortada (ver main.css): evita ver
  // as cores excedentes vazando do card no primeiro quadro
  const FITTED = "bs-swatch-fitted";

  const rows = new WeakSet();
  let resizeObserver = null;

  function fit(row) {
    const nodes = Array.prototype.filter.call(row.children, (el) => el.matches(NODE));
    const more = row.querySelector(MORE);
    if (!nodes.length || !more) return;
    // linha fora de tela (gaveta fechada, slide do carrossel ainda oculto) mede
    // zero e esconderia tudo; o ResizeObserver chama de novo quando aparecer
    if (!row.clientWidth) return;

    // volta ao estado cheio antes de medir de novo (a largura pode ter crescido)
    nodes.forEach((node) => node.classList.remove(HIDDEN));
    more.classList.add(MORE_EMPTY);

    // A borda direita util da linha: o padding de 3px existe so para o anel da
    // cor escolhida caber, entao nao conta como espaco. O meio pixel e folga
    // para larguras fracionarias.
    const style = window.getComputedStyle(row);
    const limit = row.getBoundingClientRect().right - (parseFloat(style.paddingRight) || 0) + 0.5;
    const spills = (el) => el.getBoundingClientRect().right > limit;

    if (!spills(nodes[nodes.length - 1])) {
      row.classList.add(FITTED);
      return;
    }

    // com o "+N" na linha sobra menos espaco para as amostras, entao ele entra
    // antes da contagem — senao a ultima cor visivel ficaria por baixo dele
    more.classList.remove(MORE_EMPTY);

    let hidden = 0;
    for (let i = nodes.length - 1; i >= 0 && spills(more); i--) {
      nodes[i].classList.add(HIDDEN);
      hidden++;
    }

    row.classList.add(FITTED);

    if (hidden === 0) {
      more.classList.add(MORE_EMPTY);
      return;
    }

    // So escreve quando o numero muda: o MutationObserver la embaixo escuta
    // childList, e trocar textContent pelo MESMO texto ja seria uma mutacao —
    // varredura, nova escrita, nova mutacao, em loop.
    const count = more.querySelector("[data-more-count]");
    const label = more.querySelector("[data-more-label]");
    const countText = "+" + hidden;
    if (count && count.textContent !== countText) count.textContent = countText;
    if (label) {
      if (label.dataset.template === undefined) label.dataset.template = label.textContent.trim();
      const labelText = (label.dataset.template || "").replace("__N__", hidden);
      if (label.textContent !== labelText) label.textContent = labelText;
    }
  }

  function observe(row) {
    if (rows.has(row)) return;
    rows.add(row);
    if (resizeObserver) resizeObserver.observe(row);
  }

  function scan() {
    document.querySelectorAll(ROW).forEach((row) => {
      observe(row);
      fit(row);
    });
  }

  function init() {
    if (!resizeObserver && "ResizeObserver" in window) {
      resizeObserver = new ResizeObserver((entries) => entries.forEach((entry) => fit(entry.target)));
    }
    scan();
  }

  // Cards chegam depois em varios lugares: filtro/ordenacao da categoria,
  // "carregar mais", carrosseis de recomendacao e vistos recentemente. Uma
  // varredura debounced no body cobre todos sem cada um precisar avisar.
  let pending = null;
  const observer = new MutationObserver(() => {
    if (pending) return;
    pending = requestAnimationFrame(() => {
      pending = null;
      scan();
    });
  });

  function start() {
    init();
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener("collection:rerendered", scan);
    // sem ResizeObserver (navegador antigo) o resize da janela e a rede de seguranca
    if (!resizeObserver) window.addEventListener("resize", scan);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
